import { render, staticRenderFns } from "./ClienteExibicaoMelhores.vue?vue&type=template&id=039c12cc&scoped=true&"
import script from "./ClienteExibicaoMelhores.vue?vue&type=script&lang=js&"
export * from "./ClienteExibicaoMelhores.vue?vue&type=script&lang=js&"
import style0 from "./ClienteExibicaoMelhores.vue?vue&type=style&index=0&id=039c12cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039c12cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
